import * as React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ANIMATIONS } from '../../utils';

import { CustomerQuote, type CustomerQuoteType } from './CustomerQuote';

const Wrapper = styled(motion.div)`
  width: 100%;
`;

const Inner = styled.div`
  padding: 60px 30px 120px;

  @media (min-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    padding: 80px 40px 160px;
  }
`;

const Quote = styled.div`
  display: flex;
  max-width: 450px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    max-width: none;
  }
`;

const CustomerQuotes = styled.div`
  display: flex;
  gap: 35px;
  flex: 1 1 0px;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    flex-direction: column;
    gap: 30px;
  }

  ${Quote} {
    flex: 1;
  }
`;

interface QuotesMultipleProps {
  customerQuotes: CustomerQuoteType[];
}

const QuotesMultiple: React.ComponentType<QuotesMultipleProps> = React.memo(
  ({ customerQuotes }) => {
    return (
      <Wrapper {...ANIMATIONS.SimpleFadeIn}>
        <Inner>
          <CustomerQuotes>
            {customerQuotes.map((item, index) => (
              <Quote key={index}>
                <CustomerQuote
                  author={item.author}
                  customerName={item.customer.name}
                  quote={item.quote.quote}
                />
              </Quote>
            ))}
          </CustomerQuotes>
        </Inner>
      </Wrapper>
    );
  }
);

export default QuotesMultiple;
